import CONFIG from "../../../../../config/config";

const CHATBOT_TEMPLATES = [
    {
        slug: "faq-bot",
        visible: true,
        enabled: true,
        name: {
            en: "FAQ Bot",
            tr: "Sıkça Sorulan Sorular Botu",
        },
        shortDescription: {
            en: "Answer frequently asked questions with a chatbot and save your time.",
            tr: "Sıkça sorulan soruları bir sohbet botuyla yanıtlayın ve zaman kazanın.",
        },
        description: {
            en: "Automate frequently asked questions about order and account issues.\n\n**Key features:**\n* Provide support 24/7/365.\n* Answer common questions about order,tracking and account issues.\n* Redirect users to the related product  and store pages they're looking for to improve customer experience.",
            tr: "Sipariş ve hesap sorunları hakkında sık sorulan soruları otomatikleştirin.\n\n**Temel özellikler:**\n * 7/24/365 destek sağlayın.\n * Sipariş, takip ve hesap sorunları hakkında sık sorulan soruları yanıtlayın.\n * Müşteri deneyimini iyileştirmek için kullanıcıları aradıkları ilgili ürün ve mağaza sayfalarına yönlendirin.",
        },
        imageUrl: "/static/img/chatbot/faq-bot.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["basic", "automation", "featured"],
            tr: ["temel", "otomasyon", "öne çıkan"],
        },
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "us-polo-assn",
        visible: CONFIG.AKINON.enabledReal,
        enabled: true,
        name: "US Polo ASSN - Dijital Asistan v1",
        shortDescription: "Müşterilere sipariş ve benzeri konularda yardımcı olmak için tasarlanmıştır.",
        description:
            "Automate frequently asked questions about order and account issues.\n\n**Key features:**\n* Provide support 24/7/365.\n* Answer common questions about order,tracking and account issues.\n* Redirect users to the related product  and store pages they're looking for to improve customer experience.",
        imageUrl: "/static/img/chatbot/us-polo-assn.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2022-11-10T00:00:00.000Z",
    },
    {
        slug: "pierre-cardin",
        visible: CONFIG.AKINON.enabledReal,
        enabled: true,
        name: "Pierre Cardin - Dijital Asistan v1",
        shortDescription: "Müşterilere sipariş ve benzeri konularda yardımcı olmak için tasarlanmıştır.",
        description:
            "Automate frequently asked questions about order and account issues.\n\n**Key features:**\n* Provide support 24/7/365.\n* Answer common questions about order,tracking and account issues.\n* Redirect users to the related product  and store pages they're looking for to improve customer experience.",
        imageUrl: "/static/img/chatbot/pierre-cardin.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2022-11-10T00:00:00.000Z",
    },
    {
        slug: "cacharel",
        visible: CONFIG.AKINON.enabledReal,
        enabled: true,
        name: "Cacharel - Dijital Asistan v1",
        shortDescription: "Müşterilere sipariş ve benzeri konularda yardımcı olmak için tasarlanmıştır.",
        description:
            "Automate frequently asked questions about subscription and account issues.\n\n**Key features:**\n* Provide support 24/7/365.\n* Answer common questions about subscription and account issues.\n* Redirect users to the articles and pages they're looking for to improve customer experience.",
        imageUrl: "/static/img/chatbot/cacharel.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2022-11-10T00:00:00.000Z",
    },
    {
        slug: "call-scheduling",
        visible: true,
        enabled: true,
        name: {
            en: "Call Scheduling Bot",
            tr: "Arama Planlama Botu",
        },
        shortDescription: {
            en: "Let customers call you at the click of a button or schedule a call for later.",
            tr: "Müşterilerinizi bir düğmeye tıklayarak aramalarına izin verin veya daha sonra bir arama planlayın.",
        },
        description:
            {
                en: "Let customers call you by using a chatbot or schedule a call for later.\n\n**Key features:**\n* Inform customers about your working hours\n* Make a call directly from the Chat Widget\n* Collect contact information (name, e-mail, phone number, additional message)\n* Schedule a call (pick a date and time)",
                tr: "Müşterilerinizi bir sohbet botu kullanarak aramalarına izin verin veya daha sonra bir arama planlayın.\n\n**Temel özellikler:**\n* Çalışma saatleriniz hakkında müşterileri bilgilendirin\n* Sohbet Widget'ından doğrudan arama yapın\n* İletişim bilgilerini (ad, e-posta, telefon numarası, ek mesaj) toplayın\n* Bir arama planlayın (tarih ve saat seçin)",
            },

        imageUrl: "/static/img/chatbot/schedule-a-call.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories:{
            en:["basic", "automation"],
            tr:["temel", "otomasyon"],
        },
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "online-quiz-bot",
        visible: true,
        enabled: true,
        name: {
            en: "Online Quiz Bot",
            tr: "Online Quiz Botu",
        },
        shortDescription: {
            en: "Engage your customers with a chatbot quiz tailored to your needs.",
            tr: "Müşterilerinizi ihtiyaçlarınıza göre özelleştirilmiş bir sohbet botu sınavıyla etkileşime sokun.",
        },
        description:
            {
                en:"Engage your customers with a chatbot quiz tailored to your needs.\n\n**Key features:**\n*  Ask customers five questions and display their score\n* Share tips via the Show tip button\n* Show users an explanation if they get the answer wrong\n* Use the template and its logic to create more questions\n* Share coupon codes",
                tr:"Müşterilerinizi ihtiyaçlarınıza göre özelleştirilmiş bir sohbet botu sınavıyla etkileşime sokun.\n\n**Temel özellikler:**\n* Müşterilere beş soru sorun ve puanlarını gösterin\n* İpuçlarını Göster düğmesi aracılığıyla paylaşın\n* Yanlış cevap verirlerse kullanıcılara bir açıklama gösterin\n* Daha fazla soru oluşturmak için şablonu ve mantığını kullanın\n* Kupon kodlarını paylaşın",
            },
        imageUrl: "/static/img/chatbot/online-quiz-bot.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en: ["basic", "featured", "automation"],
            tr: ["temel", "öne çıkan", "otomasyon"],
        },
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "online-quiz-bot-tr",
        visible: true,
        enabled: true,
        name: {
            en: "Online Quiz Bot",
            tr: "Online Quiz Botu",
        },
        shortDescription: {
            en:"Engage your customers with a chatbot quiz tailored to your needs.",
            tr:"İhtiyaçlarınıza göre uyarlanmış bir chatbot testi ile müşterilerinizle etkileşim kurun",
        },
        description:
            {
                en:"Engage your customers with a chatbot quiz tailored to your needs.\n\n**Key features:**\n*  Ask customers five questions and display their score\n* Share tips via the Show tip button\n* Show users an explanation if they get the answer wrong\n* Use the template and its logic to create more questions\n* Share coupon codes",
                tr:"İhtiyaçlarınıza göre uyarlanmış bir chatbot testi ile müşterilerinizle etkileşim kurun.\n\n**Temel özellikler:**\n* Müşterilere beş soru sorun ve puanlarını gösterin\n* İpuçlarını Göster düğmesi aracılığıyla paylaşın\n* Yanlış cevap verirlerse kullanıcılara bir açıklama gösterin\n* Daha fazla soru oluşturmak için şablonu ve mantığını kullanın\n* Kupon kodlarını paylaşın",
            },
        imageUrl: "/static/img/chatbot/online-quiz-bot-iki.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "featured", "automation"],
            tr:["temel", "öne çıkan", "otomasyon"],
        },
        updatedAt: "2023-09-23T00:00:00.000Z",
    },

    {
        slug: "e-commerce",
        visible: true,
        enabled: true,
        name: {
            en: "E-commerce Bot",
            tr: "E-ticaret Botu",
        },
        shortDescription: {
            en: "Improve customer experience to grow your sales.",
            tr: "Satışlarınızı artırmak için müşteri deneyimini iyileştirin.",
        },
        description:
            {
                en:"Guide customers through the whole buying process. Improve customer experience and boost sales.\n\n**Key tasks:**\n* Promote special offers\n* Add items to carts\n* Process orders\n* Provide support 24/7",
                tr:"Müşterilere tüm satın alma süreçlerinde rehberlik edin. Müşteri deneyimini iyileştirin ve satışları artırın.\n\n**Temel görevler:**\n* Özel teklifleri tanıtma\n* Sepete ürün ekleme\n* Siparişleri işleme\n* 7/24 destek sağlama",
            },
        imageUrl: "/static/img/chatbot/e-commerce.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "featured"],
            tr:["temel", "öne çıkan"],
        },
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "package-tracking-bot",
        visible: true,
        enabled: true,
        name: {
            en: "Package Tracking Bot",
            tr: "Sipariş Takip Botu",
        },
        shortDescription: {
            en: "Let customers check the delivery status in the chat window",
            tr: "Müşterilerin teslimat durumunu sohbet penceresinden kontrol etmesine izin verin",
        },
        description:
            {
                en:"Do you ship packages to your customers? Enable them to check the current status of their deliveries while chatting with a chatbot.\n\n**Key features:**\n* An advanced system that verifies the delivery status\n* Custom bot responses relevant to the package status\n* Filters that route messages",
                tr:"Siparişler gönderim aşamasında mı? Onlara bir sohbet botu ile sohbet ederken teslimatlarının güncel durumunu kontrol etme imkanı tanıyın.\n\nAna özellikler:\n* Teslimat durumunu doğrulayan gelişmiş bir sistem\n* Paket durumu ile ilgili özel bot yanıtları\n* Mesajları yönlendiren filtreler",
            },
        imageUrl: "/static/img/chatbot/package-tracking.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "automation", "featured"],
            tr:["temel", "otomasyon", "öne çıkan"],
        },
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "university-bot",
        visible: true,
        enabled: true,
        name: {
            en: "University Bot",
            tr: "Üniversite Botu",
        },
        shortDescription: {
            en:"Automate your communication and admission process.",
            tr:"İletişim ve kabul sürecinizi otomatikleştirin.",
        },
        description:
            {
              en:"Engage and support candidates on your website and social media pages. Streamline your admission process.\n\n**Key features:**\n* Explain admission procedures\n* Promote courses & open days\n* Inform users about the admission deadlines\n* Gather questions using a conversational contact form\n* Make a call directly from the chat widget",
              tr:"Sitenizde ve sosyal medya sayfalarınızda adayları etkileyin ve destekleyin. Kabul sürecinizi basitleştirin.\n\n**Ana özellikler:**\n* Kabul prosedürlerini açıklama\n* Kursları ve açık günleri tanıtma\n* Kullanıcıları kabul süreçleri hakkında bilgilendirme\n* Konuşma tabanlı iletişim formu kullanarak soruları toplama\n* Sohbet widget'ından doğrudan arama yapma",
            },
        imageUrl: "/static/img/chatbot/university.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "automation", "featured"],
            tr:["temel", "otomasyon", "öne çıkan"],
        },
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "restaurant-bot",
        visible: true,
        enabled: true,
        name: {
            en:"Restaurant Bot",
            tr:"Restoran Botu",
        },
        shortDescription: {
            en:"Automate taking orders & making reservations. Support customers 24/7.",
            tr:"Sipariş alımını ve rezervasyonları otomatikleştirin. Müşterilere 7/24 destek sağlayın.",
        },
        description:
            {
                en:"Automate taking orders and making reservations to focus on customers you are currently serving.\n\n**Key features:**\n* Present your restaurant menu\n* Take and processes orders\n* Pass orders automatically to your backend using webhooks\n* Manage table reservations\n* Provide contact information",
                tr:"Emirleri otomatikleştirin ve rezervasyonları alarak şu anda hizmet verdiğiniz müşterilere odaklanın.\n\n**Ana özellikler:**\n* Restoran menünüzü sunma\n* Emirleri alıp işleme koyma\n* Emirleri web kancalarını kullanarak otomatik olarak arka planda iletim\n* Masa rezervasyonlarını yönetme\n* İletişim bilgisi sağlama"
            },
        imageUrl: "/static/img/chatbot/restaurant.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "automation", "featured"],
            tr:["temel", "otomasyon", "öne çıkan"],
        },
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "sales-bot",
        visible: true,
        enabled: true,
        name: {
            en:"Sales Bot",
            tr:"Satış Botu",
        },
        shortDescription: {
            en:"Sell your products directly from the chat window",
            tr:"Ürünlerinizi sohbet penceresinden doğrudan satın",
        },
        description:
            {
                en:"Support customers using a smart chatbot. Promote your products and improve customer experience to make more sales.\n\n**Key features:**\n* Promote special offers, holiday deals & bestsellers\n* Take and process orders\n* Answer common questions\n* Track packages\n* Let customers leave a message in the chat window",
                tr:"Müşterilere akıllı bir sohbet botu ile destek sağlayın. Ürünlerinizi tanıtın ve müşteri deneyimini artırarak daha fazla satış yapın.\n\n**Ana özellikler:**\n* Özel teklifleri, tatil fırsatlarını ve en çok satanları tanıtma\n* Emirleri alıp işleme koyma\n* Sıkça sorulan soruları yanıtlama\n* Paketleri takip etme\n* Müşterilere sohbet penceresinde bir mesaj bırakma imkanı sağlama",
            },
        imageUrl: "/static/img/chatbot/sales-bot.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "automation", "featured", "new"],
            tr:["temel", "otomasyon", "öne çıkan", "yeni"],
        },
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "recruitment-bot",
        visible: true,
        enabled: true,
        name: {
            en:"Recruitment Bot",
            tr:"İşe Alım Botu",
        },
        shortDescription: {
            en:"Improve customer experience to grow your sales.",
            tr:"Satışlarınızı artırmak için müşteri deneyimini iyileştirin.",
        },
        description:
            {
              en:"Automate sourcing candidates and answering common questions to speed up your hiring process.\n\n**Key features:**\n* Promote open positions\n* Collect contact information\n* Generate leads\n* Answer repetitive questions",
              tr:"Adayları kaynaştırmayı ve yaygın soruları yanıtlamayı otomatize ederek işe alım sürecinizi hızlandırın.\n\n**Ana özellikler:**\n* Açık pozisyonları tanıtma\n* İletişim bilgisi toplama\n* Potansiyel adaylar oluşturma\n* Tekrarlayan soruları yanıtlama",
            },
        imageUrl: "/static/img/chatbot/recruitment-bot.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "automation", "featured"],
            tr:["temel", "otomasyon", "öne çıkan"],
        },
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "the-coffee-shop",
        visible: true,
        enabled: true,
        name: {
            en:"The Coffee Shop",
            tr:"Kahve Dükkanı",
        },
        shortDescription: {
            en:"Present your shop’s offers and collect orders in the chat window.",
            tr:"Dükkanınızın tekliflerini sunun ve siparişleri sohbet penceresinde toplayın.",
        },
        description:
            {
                en:"Present your shop’s offers and collect orders in the chat window.\n\n**Key features:**\n* Present your menu\n* Take orders",
                tr:"Mağazanızın tekliflerini sunun ve siparişleri sohbet penceresinde toplayın.\n\n**Ana özellikler:**\n* Menünüzü sunma\n* Siparişleri alma",
            },
        imageUrl: "/static/img/chatbot/coffee-shop.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories:{
            en: ["basic", "featured"],
            tr: ["temel", "öne çıkan"],
        },
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "real-estate-bot",
        visible: true,
        enabled: true,
        name: {
            en:"Real Estate Bot",
            tr:"Gayrimenkul Botu",
        },
        shortDescription: {
            en:"Promote your rental properties and find tenants quickly.",
            tr:"Kiralık mülklerinizi tanıtın ve kiracı bulun.",
        },
        description:
            {
                en:"Connect with home sellers & buyers. Automate your rental listing process and qualify leads in the chat window.\n\n**Key features:**\n* Promote rental properties\n* Collect leads in the chat window\n* Schedule calls with prospects\n* Provide your contact details\n* Let customers list their properties easily",
                tr:"Ev satıcıları ve alıcıları ile bağlantı kurun. Kiralık listeleme sürecinizi otomatize edin ve potansiyel müşterileri sohbet penceresinde değerlendirin.\n\n**Ana özellikler:**\n* Kiralık mülkleri tanıtma\n* Sohbet penceresinde potansiyel müşteri bilgisi toplama\n* Müşteri adaylarıyla görüşmeleri planlama\n* İletişim bilgilerinizi sağlama\n* Müşterilere mülklerini kolayca listeleme imkanı sağlama",
            },
        imageUrl: "/static/img/chatbot/real-estate-bot.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "automation", "featured"],
            tr:["temel", "otomasyon", "öne çıkan"],
        },
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "customer-service-bot",
        visible: true,
        enabled: true,
        name: {
            en:"Customer Service Bot",
            tr:"Müşteri Hizmetleri Botu",
        },
        shortDescription: {
            en:"Automate repetitive queries and give your customers instant answers 24/7/365.",
            tr:"Tekrarlayan soruları otomatikleştirin ve müşterilerinize 7/24 anında yanıtlar verin.",
        },
        description:
            {
                en:"Automate repetitive sales and support queries and give your customers instant, and consistent answers 24/7/365.\n\n**With Customer Service bot you’ll be able to:**\n* Navigate customers through the most important sections of your website/help center/blog.\n* Share sales and support information.\n* Start a call directly from within ChatBot.",
                tr:"Tekrarlayan satış ve destek sorularını otomatize edin ve müşterilerinize 7/24/365 anlık ve tutarlı cevaplar verin.\n\n**Müşteri Hizmetleri botu ile şunları yapabilirsiniz:**\n* Müşterileri web sitenizin/en iyi yardım merkezinizin/blog'unuzun en önemli bölümlerinden geçirme\n* Satış ve destek bilgilerini paylaşma\n* Sohbet içinden doğrudan bir arama başlatma",
            },
        imageUrl: "/static/img/chatbot/customer-satisfaction-bot.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "automation", "featured"],
            tr:["temel", "otomasyon", "öne çıkan"],
        },
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "faq-chat-bot",
        visible: true,
        enabled: true,
        name: {
            en:"FAQ BOT",
            tr:"Sıkça Sorulan Sorular Botu",
        },
        shortDescription:
            {
                en:"Automate frequently asked questions about subscription and account issues.  Key features:  Provide support 24/7. Answer common questions about subscription and account issues. Redirect users to the articles and pages they're looking for to improve customer experience.",
                tr:"Sıkça sorulan soruları abonelik ve hesap sorunlarıyla ilgili otomatize edin. Ana özellikler: 7/24 destek sağlama. Abonelik ve hesap sorunlarıyla ilgili yaygın soruları yanıtlama. Kullanıcıları aradıkları makalelere ve sayfalara yönlendirerek müşteri deneyimini iyileştirme."
            },
        description:
            {
                en:"Automate repetitive sales and support queries and give your customers instant, and consistent answers 24/7.\n\n**With Customer Service bot you’ll be able to:**\n* Navigate customers through the most important sections of your website/help center/blog.\n* Share sales and support information.\n* Start a call directly from within ChatBot.",
                tr:"Tekrarlayan satış ve destek sorularını otomatize edin ve müşterilerinize 7/24 anlık ve tutarlı cevaplar verin.\n\n**Müşteri Hizmetleri botu ile şunları yapabilirsiniz:**\n* Müşterileri web sitenizin/en önemli yardım merkezinizin/blog'unuzun bölümlerinde gezindirme\n* Satış ve destek bilgilerini paylaşma\n* SohbetBotu içinden doğrudan bir arama başlatma",
            },
        imageUrl: "/static/img/chatbot/idea-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "automation", "featured"],
            tr:["temel", "otomasyon", "öne çıkan"],
        },
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "offline-bot",
        visible: true,
        enabled: true,
        name: {
            en:"Offline Bot",
            tr:"Çevrimdışı Bot",
        },
        shortDescription: {
            en:"A bot that comes into play when a response is not received within the specified timeframe.",
            tr:"Belirtilen süre zarfında yanıt alınamadığında devreye giren bir bot.",
        },
        description: {
            en:"The Offline Bot is an automated system that comes into play when responses to user queries cannot be obtained within a specified time frame.\n\nThis bot is designed to assist users when they cannot receive support within the expected response time. Its key features include:\n\n* Providing users with basic information.\n* Directing users to relevant links.\n* Guiding for transitioning to other communication channels.",
            tr:"Offline Bot, belirli bir süre içinde kullanıcılardan gelen sorulara yanıt alınamadığında devreye giren bir otomatik sistemdir. Bu bot, kullanıcılara beklenen yanıt süresi içinde destek alamadıklarında yardımcı olmak amacıyla tasarlanmıştır. Temel özellikleri şunlardır:\n\n* Kullanıcılara temel bilgileri sağlama.\n* İlgili bağlantılara yönlendirme.\n* Diğer iletişim kanallarına geçiş için rehberlik",
        },
        imageUrl: "/static/img/chatbot/offline-icon.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "automation", "featured"],
            tr:["temel", "otomasyon", "öne çıkan"],
        },
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "restaurant-bot-tr",
        visible: true,
        enabled: true,
        name: {
            en:"Restaurant Bot (Turkish)",
            tr:"Restoran Botu (Türkçe)",
        },
        shortDescription: {
            en:"A chatbot specially designed for restaurant businesses.",
            tr:"Restoran işletmeleri için özel olarak tasarlanmış bir sohbet botu.",
        },
        description: {
            en:"The Restaurant Bot (Turkish) is a chatbot specially developed for restaurant businesses. Its primary purpose is to provide customers with quick and interactive service, enhancing the overall restaurant experience. The highlighted features of this bot include:\n\n* Displaying the menu and providing recommendations.\n* Facilitating reservation bookings.\n* Offering working hours and location information.\n* Answering frequently asked questions.",
            tr:"Restaurant Bot (Turkish), restoran işletmelerine özel olarak geliştirilmiş bir sohbet botudur. Temel amacı, müşterilere hızlı ve etkileşimli bir şekilde hizmet sunmak ve restoran deneyimini geliştirmektir. Bu botun öne çıkan özellikleri şunlardır:\n\n* Menüyü gösterme ve önerilerde bulunma.\n* Rezervasyon alımını kolaylaştırma.\n* Çalışma saatleri ve konum bilgisi sağlama.\n* Sıkça sorulan soruları yanıtlama.",
        },
        imageUrl: "/static/img/chatbot/restaurant-icon-ai.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "automation", "featured"],
            tr:["temel", "otomasyon", "öne çıkan"],
        },
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "offline-bot-en",
        visible: true,
        enabled: true,
        name: {
            en:"Offline Bot (English)",
            tr:"Çevrimdışı Bot (İngilizce)",
        },
        shortDescription: {
            en:"A bot that comes into play when a response cannot be obtained within a specified time.",
            tr:"Belirtilen süre zarfında yanıt alınamadığında devreye giren bir bot.",
        },
        description: {
            en:"The Offline Bot is an automated system that comes into play when responses to user queries cannot be obtained within a specified time frame.\n\nThis bot is designed to assist users when they cannot receive support within the expected response time. Its key features include:\n\n* Providing users with basic information.\n* Directing users to relevant links.\n* Guiding for transitioning to other communication channels.",
            tr:"Offline Bot, belirli bir süre içinde kullanıcılardan gelen sorulara yanıt alınamadığında devreye giren bir otomatik sistemdir. Bu bot, kullanıcılara beklenen yanıt süresi içinde destek alamadıklarında yardımcı olmak amacıyla tasarlanmıştır. Temel özellikleri şunlardır:\n\n* Kullanıcılara temel bilgileri sağlama.\n* İlgili bağlantılara yönlendirme.\n* Diğer iletişim kanallarına geçiş için rehberlik",
        },
        imageUrl: "/static/img/chatbot/offline-icon.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "automation", "featured"],
            tr:["temel", "otomasyon", "öne çıkan"],
        },
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "real-estate-bot-tr",
        visible: true,
        enabled: true,
        name: {
            en:"Real Estate Bot (Turkish)",
            tr:"Gayrimenkul Botu (Türkçe)",
        },
        shortDescription: {
            en:"Promote your rental properties and find tenants quickly.",
            tr:"Kiralık mülklerinizi tanıtın ve kiracı bulun.",
        },
        description: {
            en:"Connect with home sellers & buyers. Automate your rental listing process and qualify leads in the chat window.\n\n**Key features:**\n* Promote rental properties\n* Collect leads in the chat window\n* Schedule calls with prospects\n* Provide your contact details\n* Let customers list their properties easily",
            tr:"Ev satıcıları ve alıcıları ile bağlantı kurun. Kiralık listeleme sürecinizi otomatize edin ve potansiyel müşterileri sohbet penceresinde değerlendirin.\n\n**Ana özellikler:**\n* Kiralık mülkleri tanıtma\n* Sohbet penceresinde potansiyel müşteri bilgisi toplama\n* Müşteri adaylarıyla görüşmeleri planlama\n* İletişim bilgilerinizi sağlama\n* Müşterilere mülklerini kolayca listeleme imkanı sağlama",
        },
        imageUrl: "/static/img/chatbot/real-estate-house.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "automation", "featured"],
            tr:["temel", "otomasyon", "öne çıkan"],
        },
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "university-bot-tr",
        visible: true,
        enabled: true,
        name: {
            en:"University Bot (Turkish)",
            tr:"Üniversite Botu (Türkçe)",
        },
        shortDescription: {
            en:"A chatbot specifically designed for the education sector.",
            tr:"Eğitim sektörüne özel olarak tasarlanmış bir sohbet botu.",
        },
        description: {
            en:"University Bot (Turkish) is a chatbot specifically developed for the education sector. Its primary purpose is to provide students and potential students with information about the university in a quick and interactive manner, facilitating the education process. The highlighted features of this bot include:\n\n* Providing information about faculties and programs.\n* Guiding and supporting the application process.\n* Providing guidance on scholarships and financing options.\n* Offering campus tours and event information.",
            tr:"Üniversite Bot (Türkçe), eğitim sektörüne özel olarak geliştirilmiş bir sohbet botudur. Temel amacı, öğrencilere ve potansiyel öğrencilere hızlı ve etkileşimli bir şekilde üniversite ile ilgili bilgiler sunmak ve eğitim sürecini kolaylaştırmaktır. Bu botun öne çıkan özellikleri şunlardır:\n\n* Fakülteler ve programlar hakkında bilgi verme.\n* Başvuru sürecini yönlendirme ve destekleme.\n* Burs ve finansman seçenekleri konusunda rehberlik.\n* Kampüs turları ve etkinlik bilgileri sağlama.",
        },
        imageUrl: "/static/img/chatbot/university-academy-schoo.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories:{
            en:["basic", "automation", "featured"],
            tr:["temel", "otomasyon", "öne çıkan"],
        },
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "recruitment-bot-tr",
        visible: true,
        enabled: true,
        name: {
            en:"Recruitment Bot (Turkish)",
            tr:"İşe Alım Botu (Türkçe)",
        },
        shortDescription: {
            en:"A chatbot specially designed to optimize recruitment processes.",
            tr:"İnsan kaynakları süreçlerini optimize etmek amacıyla tasarlanmış bir sohbet botu.",
        },
        description: {
            en:"Recruitment Bot (Turkish) is a chatbot specifically designed to optimize the recruitment processes. The primary goal of this bot is to efficiently manage job applications in a quick and interactive manner, provide information to candidates, and enhance the overall efficiency of the recruitment process. Its standout features include:\n\n* Providing information about job listings and initiating the application process.\n* Inquiring about application status and providing real-time updates.\n* Informing about interview dates and locations.\n* Offering general company information to candidates.",
            tr:"Recruitment Bot (Turkish), işe alım süreçlerini optimize etmek amacıyla özel olarak tasarlanmış bir sohbet botudur. Bu botun temel amacı, iş başvurularını hızlı ve etkileşimli bir şekilde yönetmek, adaylara bilgi vermek ve işe alım sürecini daha verimli hale getirmektir. Öne çıkan özellikleri şunlardır:\n\n* İş ilanları hakkında bilgi verme ve başvuru sürecini başlatma.\n* Başvuru durumu sorgulama ve güncel bilgileri sunma.\n* Mülakat tarihleri ve yerleri hakkında bilgilendirme.\n* Adaylara genel şirket bilgisi sağlama.",

        },
        imageUrl: "/static/img/chatbot/recruitment.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "automation", "featured"],
            tr:["temel", "otomasyon", "öne çıkan"],
        },
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "package-tracking-bot-tr",
        visible: true,
        enabled: true,
        name: {
            en:"Package Tracking Bot (Turkish)",
            tr:"Sipariş Takip Botu (Türkçe)",
        },
        shortDescription: {
            en:"Let customers check the delivery status in the chat window",
            tr:"Müşterilerin teslimat durumunu sohbet penceresinden kontrol etmesine izin verin",
        },
        description:
            {
                en:"Do you ship packages to your customers? Enable them to check the current status of their deliveries while chatting with a chatbot.\n\n**Key features:**\n* An advanced system that verifies the delivery status\n* Custom bot responses relevant to the package status\n* Filters that route messages",
                tr:"Siparişler gönderim aşamasında mı? Onlara bir sohbet botu ile sohbet ederken teslimatlarının güncel durumunu kontrol etme imkanı tanıyın.\n\nAna özellikler:\n* Teslimat durumunu doğrulayan gelişmiş bir sistem\n* Paket durumu ile ilgili özel bot yanıtları\n* Mesajları yönlendiren filtreler",
            },
        imageUrl: "/static/img/chatbot/package-shipping-and-delivery.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: {
            en:["basic", "automation", "featured"],
            tr:["temel", "otomasyon", "öne çıkan"],
        },
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
];

export default CHATBOT_TEMPLATES;
